const axios = require('axios');
const { v4: uuid } = require('uuid');
const { getAxiosInstance } = require('../connection');

module.exports = {
    sendEventObject: function (eventId, file, uid, skipStatusUpdates) {
        uid || (uid = uuid());

        if (file.type.match(/image/) || file.type.match(/video/)) {
            let url = '';

            return getAxiosInstance({
                method: 'POST',
                url:  '/awsFileUpload',
                data: {
                    uid,
                    eventid: eventId,
                    mime_type: file.type.match(/\/(\w+)$/)[1],
                    kind: file.type.match(/^(\w+)\//)[1],
                    length: file.size,
                },
            })
                .then((response) => response.data)
                .then((data) => {
                    url = data.sent;
                    return skipStatusUpdates || updateUploadStatus(uid, 'uploading');
                })
                .then((data) => {
                    return axios
                        .put(url, file, {
                            headers: {
                                'Content-Type': file.type,
                            },
                        })
                        .then(() => skipStatusUpdates || updateUploadStatus(uid, 'ready'))
                        .catch((err) => {
                            console.error(err);
                            return skipStatusUpdates || updateUploadStatus(uid, 'upload_error');
                        });
                })
                .then(() => uid);
        } else {
            return Promise.reject(new Error('Invalid file type: ' + file.type));
        }
    },
};

function updateUploadStatus(uid, status) {
    return getAxiosInstance({
        method: 'GET',
        url:  '/awsFileUpload',
        params: { uid, status },
    });
}
